import script from "./AutocompleteInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AutocompleteInput.vue?vue&type=script&setup=true&lang=js"

import "./AutocompleteInput.vue?vue&type=style&index=0&id=383f3bb8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383f3bb8"]])

export default __exports__